/**
 * Strip GST payload from react-admin saves unless the user explicitly applied changes
 * via Manage GSTs (gsts_managed flag).
 */
export const stripUnmanagedGsts = <T extends Record<string, unknown>>(data: T): T => {
    if (data.gsts_managed === true) {
        return data;
    }

    const { gsts, gsts_managed, ...rest } = data;
    return rest as T;
};
